import MenuHeader from "../components/menu_header";
import { connect } from 'react-redux';

function mapStateToProps(state) {
  return {
    doNotDisturbEnabled: state.doNotDisturbEnabled
  };
}
export default connect(mapStateToProps)(MenuHeader);
